// extracted by mini-css-extract-plugin
export default {"page":"src-pages-loading__page","logo":"src-pages-loading__logo","_pulse":"src-pages-loading___pulse"};